module.exports = __webpack_public_path__ + "img/111018.54b195ba.png";